import { Controller } from "@hotwired/stimulus"

// Two-step SweetAlert for generated Record Book entry delete when a linked game
// can be re-checked. Matches confirmation.js styling; uses locked Phase 1 copy.
export default class extends Controller {
  static targets = ["checkField"]
  static values = {
    canCheck: Boolean
  }

  confirm(event) {
    if (this.element.dataset.deleteConfirmed === "true") {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    if (typeof window.Swal === "undefined") {
      this.element.dataset.deleteConfirmed = "true"
      this.element.requestSubmit()
      return
    }

    window.Swal.fire({
      title: "Delete this record?",
      text: "It will be removed from the list. A new holder is not added automatically.",
      showCancelButton: true,
      confirmButtonText: "Yes",
      keydownListenerCapture: true,
      confirmButtonAriaLabel: "Confirm delete",
      cancelButtonText: "Cancel",
      cancelButtonAriaLabel: "Cancel delete",
      customClass: this.swalClasses()
    }).then((deleteResult) => {
      if (!deleteResult.isConfirmed) {
        return
      }

      if (!this.canCheckValue) {
        this.setCheckField("0")
        this.element.dataset.deleteConfirmed = "true"
        this.element.requestSubmit()
        return
      }

      window.Swal.fire({
        title: "Check for a new holder?",
        text: "We'll check this game's latest stats. If something qualifies, it appears as a pending finding — you still need to Confirm Record to add it to the list.",
        showCancelButton: true,
        confirmButtonText: "Check for new holder",
        keydownListenerCapture: true,
        confirmButtonAriaLabel: "Check for new holder",
        cancelButtonText: "Skip",
        cancelButtonAriaLabel: "Skip check",
        customClass: this.swalClasses()
      }).then((checkResult) => {
        this.setCheckField(checkResult.isConfirmed ? "1" : "0")
        this.element.dataset.deleteConfirmed = "true"
        this.element.requestSubmit()
      })
    })
  }

  setCheckField(value) {
    if (this.hasCheckFieldTarget) {
      this.checkFieldTarget.value = value
    }
  }

  swalClasses() {
    return {
      title: "color-fanword-black font-fanword-regular",
      confirmButton: "btn btn-sm px-4 py-2 text-decoration-none border-0 border-fanword-positive bg-fanword-positive color-fanword-black fanword-border-radius",
      cancelButton: "btn btn-sm px-4 py-2 text-decoration-none fanword-border bg-fanword-white color-fanword-black fanword-border-radius"
    }
  }
}
